import DOMPurify from "dompurify";

/**
 * Etiquetas que pueden traer los avisos de la barra de estado: los generales los redacta IronIA y algunos
 * personales llevan un enlace ("Ver solicitud") o negritas. Todo lo demás se elimina.
 */
const AllowedTags = ["a", "b", "strong", "i", "em", "u", "br", "p", "span"];

/**
 * Atributos permitidos. Solo los de los enlaces: nada de estilos ni manejadores de eventos (onerror, onload...).
 * DOMPurify ya descarta por defecto los href con "javascript:" y similares.
 */
const AllowedAttributes = ["href", "target", "rel"];

/**
 * Sanea el texto de un aviso de la barra de estado antes de pintarlo con dangerouslySetInnerHTML.
 *
 * El backend ya codifica los datos de usuario que mete en los avisos, pero el texto se guarda en base de datos
 * y se pinta como HTML: si alguna vía deja pasar una etiqueta, aquí se quita antes de que se ejecute en la
 * sesión del usuario (auditoría de seguridad G1-02).
 */
export function sanitizeStatusBarHtml(html?: string | null): string
{
    if(!html)
    {
        return "";
    }

    return DOMPurify.sanitize(html, { ALLOWED_TAGS: AllowedTags, ALLOWED_ATTR: AllowedAttributes });
}
